export const shipDetailItemsLabels = {
    launchDate: { label: 'shipLaunchDate' },
    refurbishmentYear: { label: 'shipRefurbishmentYear' },
    company: { label: 'shipCompany' },
    length: { label: 'shipLength' },
    draft: { label: 'shipDraft' },
    speed: { label: 'shipSpeed' },
    decks: { label: 'shipDecks' },
    passengers: { label: 'shipPassengers' },
    crew: { label: 'shipCrew' },
    boardLanguage: { label: 'shipBoardLanguage' },
    boardCurrency: { label: 'shipBoardCurrency' },
};
